var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"message"}},[_c('h2',[_vm._v("message goes here... "+_vm._s(_vm.currentRouteName))])])}
var staticRenderFns = []

export { render, staticRenderFns }